import { Dic } from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
export const personOption = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: false,
    index: false,
    radio: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    size: "small",
    maxHeight: "100%",
    labelWidth: "140px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: "550px",
    emptyText: "暂无数据",
    column: [
      {
        label: "账户名称",
        prop: "accountNumber",
        editDisabled: true,
        overHidden: true,
        span: 12
      },
      {
        label: "姓名",
        prop: "nickName",
        formslot: true,
        addDisplay: true,
        editDisplay: true,
        // viewDisplay: false,
        overHidden: true,
        search: true,
        searchPlaceholder: "请输入姓名",
        span: 12,
      },
      {
        label: "性别",
        prop: "sex",
        type: "select",
        // formslot: true,
        addDisplay: true,
        editDisplay: true,
        // viewDisplay: false,
        overHidden: true,
        search: false,
        searchPlaceholder: "请选择",
        span: 12,
        formatter: function (row, value) {
          return value === 0 ? '女': value === 1 ? '男': '未识别';
        }
      },
      {
        label: "电话",
        prop: "phone",
        type: "text",
        value: "",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formatter: (row, value) => {
          if (null != value && value != undefined) {
            let pat = /(\d{3})\d*(\d{4})/;
            return value.replace(pat, "$1****$2");
          } else {
            return value;
          }
        },
        span: 12
      },
      {
        label: "所属园区",
        prop: "parkName",
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        addDisabled: false,
        editDisabled: true,
        viewDisabled: false
      },
      {
        label: "创建时间",
        prop: "createTime",
        type: "datetime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        overHidden: true,
        // format: 'yyyy-MM-dd hh:mm:ss',
        valueFormat: "timestamp",
        span: 13,
        // align: 'center',
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        }
      }
    ]
  };
};
